import { useTranslation } from "react-i18next";
import logo from "../../assets/img/logo.png"; // adapte le chemin si besoin
import { Link } from "react-router-dom";
import { FaMapMarkerAlt, FaEnvelope, FaPhone } from "react-icons/fa";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="Footer">
      <div className="footer-top">
        <div className="footer-left">
          <img src={logo} alt="Artful English Club" className="footer-logo" />
          <div className="footer-contact">
            <div>
              <FaMapMarkerAlt />{" "}
              <a href="https://maps.app.goo.gl/o3fxT9Y1wA3BUzXz6">
                {t("footer.address")}
              </a>
            </div>
            <div>
              <FaEnvelope />{" "}
            <a href="mailto:contact@artfulenglish.com">{t("footer.email")}</a>
            </div>
            <div>
              <FaPhone /> <a href="tel:+33(0) 6 63 20 78 47">{t("footer.phone1")}</a>
              <FaPhone /> <a href="tel:+33(0) 6 84 38 34 82">{t("footer.phone2")}</a>
            </div>
          </div>
        </div>

        <div className="footer-right">
          <Link to="/">{t("nav.home")}</Link>
          <Link to="/about">{t("nav.about")}</Link>
          <Link to="/awakening">{t("awakening.title")}</Link>
          <Link to="/contact">{t("nav.contact")}</Link>
        </div>
      </div>

      <div className="footer-center">
        <span>© Artful English Club 2025</span> •{" "}
        <Link to="/legal">{t("footer.legal")}</Link> 
        
      </div>
      <div>
        <p>
          Made with 💜 by{" "}
          <a
            className="links"
            rel="noreferrer"
            target="_blank"
            href="https://maelcorp.com/"
          >
            {t("footer.mael")}
          </a>
        </p>
      </div>
    </footer>
  );
}
